import { getStatusDisplayKind, getStatusLogicMode, STATUS_LOGIC_MODES, STATUS_DISPLAY_KINDS } from './statusLights';
import greenXS from '../assets/img/status-lights/legacy-webchart/green_xs_10.png';
import yellowXS from '../assets/img/status-lights/legacy-webchart/yellow_xs_10.png';
import redXS from '../assets/img/status-lights/legacy-webchart/red_xs_10.png';
import greenS from '../assets/img/status-lights/legacy-webchart/green_s_16.png';
import yellowS from '../assets/img/status-lights/legacy-webchart/yellow_s_16.png';
import redS from '../assets/img/status-lights/legacy-webchart/red_s_16.png';
import greenM from '../assets/img/status-lights/legacy-webchart/green_m_20.png';
import yellowM from '../assets/img/status-lights/legacy-webchart/yellow_m_20.png';
import redM from '../assets/img/status-lights/legacy-webchart/red_m_20.png';
import greenL from '../assets/img/status-lights/legacy-webchart/green_l_24.png';
import yellowL from '../assets/img/status-lights/legacy-webchart/yellow_l_24.png';
import redL from '../assets/img/status-lights/legacy-webchart/red_l_24.png';
import greenXL from '../assets/img/status-lights/legacy-webchart/green_xl_30.png';
import yellowXL from '../assets/img/status-lights/legacy-webchart/yellow_xl_30.png';
import redXL from '../assets/img/status-lights/legacy-webchart/red_xl_30.png';

const imageStyles = {
    7: { size: 10, green: greenXS, yellow: yellowXS, red: redXS },
    8: { size: 16, green: greenS, yellow: yellowS, red: redS },
    2: { size: 20, green: greenM, yellow: yellowM, red: redM },
    9: { size: 24, green: greenL, yellow: yellowL, red: redL },
    10: { size: 30, green: greenXL, yellow: yellowXL, red: redXL }
};
const emojiStyles = {
    3: { green: '😊', yellow: '😮', red: '😨' },
    4: { green: '😁', yellow: '😕', red: '😡' },
    5: { green: '✅', yellow: '⚠️', red: '🛑' },
    6: { green: '🆗', yellow: '❓', red: '‼️' }
};

// The legend and table use one definition of the project's active style.
export function getStatusLightAppearance(light, project) {
    const kind = getStatusDisplayKind(project);
    const legacy = getStatusLogicMode(project) === STATUS_LOGIC_MODES.LEGACY;
    if (kind === STATUS_DISPLAY_KINDS.GRADIENT_CIRCLE || kind === STATUS_DISPLAY_KINDS.GRADIENT_CIRCLE_WITH_TEXT)
        return { type: 'circle', withText: kind === STATUS_DISPLAY_KINDS.GRADIENT_CIRCLE_WITH_TEXT };
    if (legacy) {
        const image = imageStyles[kind];
        if (image?.[light.color]) return { type: 'image', src: image[light.color], size: image.size };
        if (emojiStyles[kind]) return { type: 'emoji', text: emojiStyles[kind][light.color] };
    } else if (kind === 2) {
        return { type: 'text', text: light.colorName };
    }
    return { type: 'block', text: !legacy && kind === 1 ? '' : light.colorName,
        background: light.background, foreground: light.foreground };
}
